module.exports = __webpack_public_path__ + "img/aboutOur.89f8ccc4.png";